import { render, staticRenderFns } from "./greenlist.vue?vue&type=template&id=1a809ea1&scoped=true"
import script from "./greenlist.vue?vue&type=script&lang=js"
export * from "./greenlist.vue?vue&type=script&lang=js"
import style0 from "./greenlist.vue?vue&type=style&index=0&id=1a809ea1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a809ea1",
  null
  
)

export default component.exports